
export const createTableListaProfiliProjektu = () => {


    return [
        {
            accessorKey: 'user_id',
            header: 'ID użytkownika',
            filterFn: 'includesString',

        },
        {
            accessorKey: 'email',
            header: 'Email',
            filterFn: 'includesString',
        },

    ]
}